
<p-confirmDialog key="continueDialog" class="continue-confirm-dialog" #confirmContinue>
  <p-footer>
    <button id="btn-confirm-cancel" class="btn btn-outline-secondary btn-confirm-cancel" type="button" label="Cancel" (click)="confirmContinue.reject()">Cancel</button>
    <button class="btn btn-primary btn-confirm-continue" type="button" label="Continue" (click)="confirmContinue.accept()">Continue</button>
  </p-footer>
</p-confirmDialog>
